// Brand: Milano
// Flow: PreOrder

import React, { useState, useEffect } from 'react'

import PreOrderMenu from "../../../components/PreOrderMenu"
import withAppState from '../../../mobx/withAppState';
import { Steps } from '../../../lib/constants';

import milogo from '../../../assets/milano/milano-logo-header.svg';

const PreOrderMenuWrapper = (props) => {
  const backButtonHandler = () => {
    props.popStep();
  }

  const payButtonHandler = () => {
    props.goToStep(Steps.TABLE_PICKER)
  }
  const homeButtonHandler = () => {
    props.goToStep(Steps.DEFAULT)
  }

  const logo = (
    <a href="https://milano.ie/">
      <img src={milogo} alt="Milano" />
    </a>
)

useEffect(() => {

  let params = new URL(document.location.toString()).searchParams;
  let restaurantUrlId = params.get("restaurantId");
  if (props.activeStep === Steps.DEFAULT && !!restaurantUrlId) {  

      let promise = fetch(`api/Restaurant/GetSingleRestaurant/test/${restaurantUrlId}`);

      promise.then((response) => {
          response.json().then((restaurantData) => {
              props.selectRestaurant(restaurantData);
              props.setRestaurantUrl(restaurantData.restaurantUrlName);
              console.error('Error fetching restaurant')
          });
      });
  }
},[]);

  return <PreOrderMenu logo={logo} payButtonHandler={payButtonHandler} backButtonHandler={backButtonHandler} homeButtonHandler={homeButtonHandler} activeStep={props.activeStep} isOrderJourney={props.isOrderJourney}/>

}

export default withAppState(PreOrderMenuWrapper, {
  mobXProps: ({
    activeStep,
    isOrderJourney,
    restaurant
  }) => ({
    activeStep,
    isOrderJourney,
    restaurant
  }),
  mobXActions: ({
    goToStep,
    popStep,
    getCurrency,
    setRestaurantUrl,
    selectRestaurant
  }) => ({
    goToStep,
    popStep,
    getCurrency,
    setRestaurantUrl,
    selectRestaurant
  })
});